import type { Locale } from '@susu/headless-commerce/config/locale'
import type { CountryConfiguration } from '@susu/headless-commerce/types/CountryConfiguration'
import type { PageType } from '@susu/headless-commerce/types/PageType'
import { trackEvent } from './tracking'

type TrackLanguageSelectorClickedParams = {
  country: CountryConfiguration
  locale: Locale
  eventLocation: 'menu' | 'footer'
  locationId: string
  pageType: PageType
  url: string
}

export const trackLanguageSelectorClicked = ({
  country,
  locale,
  eventLocation,
  locationId,
  pageType,
  url,
}: TrackLanguageSelectorClickedParams) => {
  trackEvent({
    segment: {
      enrichProps: {
        country,
        locale,
      },
      event: 'languageSelectorClicked',
      properties: {
        eventCategory: 'global_interactions',
        eventLabel: '',
        eventLocation,
        locationId,
        pageType,
        url,
      },
    },
  })
}
